import * as React from "react";
import Drawer from "@mui/material/Drawer";
import MainLogo from "../../../assets/images/mainlogoNew.png";
import { Box, Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomButton from "../../button/CustomButton";

const drawerWidth = 200;

export default function Sidebar({
  isAgentPanel,
  mobileOpen,
  handleDrawerToggle,
  hideSidebarOnDesktop,
}) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const UserRoutes = [
    {
      name: t("home"),
      to: "/",
    },
    {
      name: t("Headings.My Property"),
      to: "/my-property",
    },
    {
      name: t("Headings.Buy & Rent Property"),
      to: "/buy-property",
    },
    {
      name: t("Headings.My Visits"),
      to: "/user-schedule-visit",
    },
    {
      name: t("Headings.My Wishlist"),
      to: "/wishlists",
    },
    {
      name: t("Settings.Settings"),
      to: "/user-settings?tab=4",
    },
  ];

  const AgentRoutes = [
    {
      name: t("home"),
      to: "/",
    },
    {
      name: t("Headings.Visit Property"),
      to: "/agent-dashboard",
    },
    {
      name: t("Headings.Manage Visit"),
      to: "/manage-property-visit",
    },
    {
      name: t("Headings.Audit Property"),
      to: "/audit-property",
    },
    {
      name: t("Headings.Manage Audit"),
      to: "/manage-property-audit",
    },
    {
      name: t("My_commission.My Commissions - Sale"),
      to: "/my-commission-sale",
    },
    {
      name: t("My_commission.My Commissions - Audit"),
      to: "/my-commission-rent",
    },
    {
      name: t("My_commission.My Agent"),
      to: "/my-agents-list",
    },
    {
      name: t("Agent_dashboard.Add Agent"),
      to: "/add-agent",
    },
    {
      name: t("Settings.Settings"),
      to: "/agent-settings?tab=4",
    },
  ];

  const routes = isAgentPanel ? AgentRoutes : UserRoutes;

  const isRouteActive = (routePath) => {
    const [path, search] = routePath.split("?");
    const normalizedSearch = search ? `?${search}` : "";

    return location.pathname === path && (normalizedSearch === "" || location.search === normalizedSearch);
  };

  return (
    <>
      {/* Desktop Drawer */}
      {!hideSidebarOnDesktop && (
        <Drawer
          sx={{
            display: { xs: "none", md: "block" },
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              // boxSizing: "border-box",
              // border: "none",
              // borderRadius: "24px",
              // margin: "16px",
              // marginTop: "81px",
              // height: "calc(100vh)",
              backgroundColor: "#FFFFFF",
              // Hide scrollbar
              "&::-webkit-scrollbar": {
                display: "none",
              },
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            },
          }}
          variant="permanent"
          anchor="left"
          open
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              padding: "12px 10px",
              // Hide scrollbar
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
          >
            {/* Logo */}
            <Box sx={{ textAlign: "center", mt: 2, mb: 2 }}>
              <Link to="/">
                <img
                  style={{ width: "160px", height: "auto" }}
                src={MainLogo}
                alt="Easy Property"
                className="logo-img"
              />
            </Link>
          </Box>

          <Box
            sx={{
              borderBottom: "2px solid #F1F5F9",
              mb: 3,
              // mx: 1,
            }}
          />

          {/* Navigation Items */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              flex: 1,
            }}
          >
            {routes.map((route, index) => {
              const isActive = isRouteActive(route.to);

              return (
                <Box
                  key={index}
                  onClick={() => navigate(route.to)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 16px",
                    mx: 1,
                    borderRadius: "10px",
                    borderLeft: isActive ? "4px solid #0085FD" : "4px solid transparent",
                    backgroundColor: isActive ? "rgba(0, 133, 253, 0.1)" : "transparent",
                    color: isActive ? "#003C8F" : "#1E293B",
                    cursor: "pointer",
                    transition: "all 0.2s ease-in-out",
                    boxShadow: isActive ? "0 2px 10px rgba(0, 133, 253, 0.1)" : "none",
                    "&:hover": {
                      backgroundColor: isActive ? "rgba(0, 133, 253, 0.14)" : "#F1F5F9",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: isActive ? 700 : 600,
                      lineHeight: "20px",
                    }}
                  >
                    {route.name}
                  </Typography>
                </Box>
              );
            })}
          </Box>

          {/* Footer */}
          <Box
            sx={{
              mt: "auto",
              pt: 3,
              borderTop: "1px solid #F1F5F9",
            }}
          >
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 600,
                color: "#1E293B",
                mb: 0.5,
              }}
            >
              Easy Property
            </Typography>
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 400,
                color: "#94A3B8",
                lineHeight: "16px",
              }}
            >
              © {currentYear} {t("Profile.All Rights Reserved")}
            </Typography>
          </Box>
        </Box>
        </Drawer>
      )}

      {/* Mobile Drawer */}
      <Drawer
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            border: "none",
            backgroundColor: "#FFFFFF",
            borderTopRightRadius: "24px",
            borderTopRightRadius: "24px",
            borderBottomRightRadius: "24px",
            // Hide scrollbar
            "&::-webkit-scrollbar": {
              display: "none",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          },
        }}
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            padding: "32px 20px",
            // Hide scrollbar
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          {/* Logo */}
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Link to="/" onClick={handleDrawerToggle}>
              <img
                style={{ width: "80px", height: "auto" }}
                src={MainLogo}
                alt="Easy Property"
              />
            </Link>
          </Box>

          <Box
            sx={{
              borderBottom: "2px solid #F1F5F9",
              mb: 3,
              mx: 1,
            }}
          />

          {/* Navigation Items */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              flex: 1,
            }}
          >
            {routes.map((route, index) => {
              const isActive = isRouteActive(route.to);

              return (
                <Box
                  key={index}
                  onClick={() => {
                    navigate(route.to);
                    handleDrawerToggle();
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 16px",
                    borderRadius: "12px",
                    backgroundColor: isActive ? "#7C3AED" : "transparent",
                    color: isActive ? "#FFFFFF" : "#64748B",
                    cursor: "pointer",
                    transition: "all 0.2s ease-in-out",
                    boxShadow: isActive ? "0 2px 10px rgba(124, 58, 237, 0.16)" : "none",
                    borderLeft: isActive ? "4px solid #FFFFFF" : "4px solid transparent",
                    "&:hover": {
                      backgroundColor: isActive ? "#7C3AED" : "#F1F5F9",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: isActive ? 700 : 500,
                      lineHeight: "20px",
                    }}
                  >
                    {route.name}
                  </Typography>
                </Box>
              );
            })}
          </Box>

          {/* Footer */}
          <Box
            sx={{
              mt: "auto",
              pt: 3,
              borderTop: "1px solid #F1F5F9",
            }}
          >
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 600,
                color: "#1E293B",
                mb: 0.5,
              }}
            >
              Easy Property
            </Typography>
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 400,
                color: "#94A3B8",
                lineHeight: "16px",
              }}
            >
              © {currentYear} {t("Profile.All Rights Reserved")}
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}